import { render, staticRenderFns } from "./SettlementWidget.vue?vue&type=template&id=0312808b&scoped=true"
import script from "./SettlementWidget.vue?vue&type=script&lang=js"
export * from "./SettlementWidget.vue?vue&type=script&lang=js"
import style0 from "./SettlementWidget.vue?vue&type=style&index=0&id=0312808b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0312808b",
  null
  
)

export default component.exports